var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9746",
    "data-name": "Grupo 9746",
    transform: "translate(-775 -334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6507",
    "data-name": "Trazado 6507",
    d: "M432.623,42.043h-14.9a3.892,3.892,0,0,1-3.871-3.906V23.105a1.562,1.562,0,0,1,.956-1.444A1.541,1.541,0,0,1,416.5,22l17.219,17.374a1.57,1.57,0,0,1,.336,1.7,1.549,1.549,0,0,1-1.431.964ZM416.95,26.878V38.136a.779.779,0,0,0,.774.781h11.16Z",
    transform: "translate(399.828 312.458)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6508",
    "data-name": "Trazado 6508",
    d: "M199.977,96.536H148.72a3.892,3.892,0,0,1-3.872-3.906V25.442a3.893,3.893,0,0,1,3.872-3.906h36.36a1.54,1.54,0,0,1,1.095.458l17.219,17.374a1.569,1.569,0,0,1,.454,1.1V92.63a3.893,3.893,0,0,1-3.872,3.906ZM148.72,24.662a.779.779,0,0,0-.774.781V92.631a.779.779,0,0,0,.774.781h51.257a.779.779,0,0,0,.774-.781V41.121L184.438,24.662Z",
    transform: "translate(630.152 312.464)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6509",
    "data-name": "Trazado 6509",
    d: "M207.56,334.367h-8.13a1.554,1.554,0,0,1-1.549-1.562v-20.63a3.892,3.892,0,0,1,3.871-3.906h3.484a3.892,3.892,0,0,1,3.871,3.906V332.8A1.554,1.554,0,0,1,207.56,334.367Zm-6.582-3.125h5.033V312.174a.779.779,0,0,0-.774-.781h-3.484a.779.779,0,0,0-.774.781Z",
    transform: "translate(584.745 67.334)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6510",
    "data-name": "Trazado 6510",
    d: "M320.64,306.745h-8.13a1.555,1.555,0,0,1-1.549-1.562V279.864a3.893,3.893,0,0,1,3.871-3.906h3.484a3.893,3.893,0,0,1,3.871,3.906v25.318a1.554,1.554,0,0,1-1.548,1.563Zm-6.582-3.125h5.033V279.864a.779.779,0,0,0-.774-.781h-3.484a.779.779,0,0,0-.774.781Z",
    transform: "translate(487.925 94.956)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6511",
    "data-name": "Trazado 6511",
    d: "M433.709,352.781h-8.13a1.554,1.554,0,0,1-1.548-1.562v-17.5a3.892,3.892,0,0,1,3.872-3.906h3.484a3.892,3.892,0,0,1,3.871,3.906v17.5A1.554,1.554,0,0,1,433.709,352.781Zm-6.582-3.125h5.034V333.714a.779.779,0,0,0-.774-.781H427.9a.779.779,0,0,0-.775.781Z",
    transform: "translate(391.114 48.919)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6512",
    "data-name": "Trazado 6512",
    d: "M435.124,237.839a5.864,5.864,0,0,1-4.64-9.4,5.832,5.832,0,1,1,4.64,9.4Zm0-8.609a2.669,2.669,0,0,0-2.166,1.091,2.7,2.7,0,0,0-.561,1.644,2.718,2.718,0,1,0,2.727-2.735Z",
    transform: "translate(386.603 137.576)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6513",
    "data-name": "Trazado 6513",
    d: "M491.84,258.835H490.2a1.563,1.563,0,0,1,0-3.125h1.641a1.563,1.563,0,0,1,0,3.125Z",
    transform: "translate(335.787 112.266)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6514",
    "data-name": "Trazado 6514",
    d: "M253.588,193.173a1.546,1.546,0,0,1-1.37-.831,1.57,1.57,0,0,1,.643-2.112l9.725-5.2a1.541,1.541,0,0,1,2.094.648,1.57,1.57,0,0,1-.643,2.112l-9.725,5.2A1.527,1.527,0,0,1,253.588,193.173Z",
    transform: "translate(538.375 172.85)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6515",
    "data-name": "Trazado 6515",
    d: "M182.3,238.705h-2.37a1.563,1.563,0,0,1,0-3.125h2.37a1.563,1.563,0,0,1,0,3.125Z",
    transform: "translate(601.442 129.475)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6516",
    "data-name": "Trazado 6516",
    d: "M380.633,199a1.529,1.529,0,0,1-.926-.312l-9.448-7.141a1.572,1.572,0,0,1-.312-2.187,1.541,1.541,0,0,1,2.169-.313l9.447,7.141a1.572,1.572,0,0,1,.312,2.187A1.546,1.546,0,0,1,380.633,199Z",
    transform: "translate(437.685 169.524)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6517",
    "data-name": "Trazado 6517",
    d: "M322.054,153a5.842,5.842,0,0,1-5.142-3.117,5.961,5.961,0,0,1-.682-2.758,5.815,5.815,0,1,1,10.477,3.507A5.782,5.782,0,0,1,322.054,153Zm0-8.625a2.742,2.742,0,0,0-2.726,2.75,2.8,2.8,0,0,0,.317,1.287,2.745,2.745,0,0,0,2.409,1.464,2.645,2.645,0,0,0,2.16-1.1,2.785,2.785,0,0,0,.551-1.653,2.734,2.734,0,0,0-2.711-2.75Z",
    transform: "translate(483.414 210.119)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6518",
    "data-name": "Trazado 6518",
    d: "M200.15,212.422a5.792,5.792,0,0,1-5.723-4.847,4.278,4.278,0,0,1-.1-1.028,5.807,5.807,0,0,1,11.313-1.9,5.664,5.664,0,0,1,.316,1.9,5.848,5.848,0,0,1-5.807,5.874Zm0-8.609a2.733,2.733,0,0,0-2.725,2.735,1.691,1.691,0,0,0,.03.385,2.771,2.771,0,0,0,2.7,2.365,2.734,2.734,0,0,0,2.71-2.75,2.579,2.579,0,0,0-.142-.863A2.718,2.718,0,0,0,200.15,203.813Z",
    transform: "translate(587.787 159.304)",
    fill: "#111111"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step_4.5b7b2c7a6d804b453c549db4acf736df.svg";
export { ForwardRef as ReactComponent };